export default __webpack_public_path__ + "static/media/TopGator.1655ab7f.jpg";